import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/pos-admin/pos-admin/layouts/default.vue").then(m => m.default || m)),
  docs: defineAsyncComponent(() => import("/home/runner/work/pos-admin/pos-admin/layouts/docs.vue").then(m => m.default || m)),
  "pre-login": defineAsyncComponent(() => import("/home/runner/work/pos-admin/pos-admin/layouts/pre-login.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/home/runner/work/pos-admin/pos-admin/layouts/public.vue").then(m => m.default || m))
}